export type AnomalySeverity = 'info' | 'warn' | 'alert';

export interface AnomalyChipProps {
  severity: AnomalySeverity;
  reason: string;
}

const LABEL: Record<AnomalySeverity, string> = {
  info: 'הערה',
  warn: 'אנומליה',
  alert: 'התראה',
};

export function AnomalyChip({ severity, reason }: AnomalyChipProps) {
  return (
    <span className={`honesty-anomaly anomaly-${severity}`} title={reason}>
      <span className="anomaly-dot" /> {LABEL[severity]} · <bdi>{reason}</bdi>
    </span>
  );
}
